import React from "react";

import TableRow from "@material-ui/core/TableRow";

import Selection from "./Selection";
import Actions from "./Actions";
import Columns from "./Columns";

class Row extends React.Component {
  clickTimeout = null;

  state = {
    isEditing: this.props.isEditing || false,
    isDeleting: false,
    row: { ...this.props.row },
  };
  onEditChange(key, value) {
    this.props.onEditChange({
      ...this.state.row,
      [key]: value,
    });

    this.setState({
      ...this.state,
      row: {
        ...this.state.row,
        [key]: value,
      },
    });
  }

  onEdit() {
    this.setState({
      ...this.state,
      isEditing: true,
    });
  }

  onDelete() {
    this.setState({
      ...this.state,
      isDeleting: true,
    });
  }

  async onConfirm() {
    const { isEditing, isDeleting } = this.state;

    if (isEditing) {
      const { row } = this.state;

      const onEdit = this.props.onEdit || null;
      if (onEdit) {
        const result = await onEdit(row);
        if (!result) {
          return;
        }
      }

      return this.setState({
        ...this.state,
        isEditing: false,
      });
    }

    if (isDeleting) {
      const { row } = this.props;

      const onDelete = this.props.onDelete || null;
      if (onDelete) {
        const result = await onDelete(row);
        if (!result) {
          return;
        }
      }

      return this.setState({
        ...this.state,
        isDeleting: false,
      });
    }
  }

  onCancel() {
    const isEditing = this.props.isEditing || false;

    this.setState({
      ...this.state,
      isEditing,
      isDeleting: false,
    });

    const onCancel = this.props.onCancel || null;
    if (onCancel) {
      const { row } = this.props;
      onCancel(row);
    }
  }

  onRowClick() {
    const { type } = this.props;

    if (type === "header") {
      return;
    }

    if (this.props.isCreateRow) {
      return;
    }

    if (this.clickTimeout) {
      clearTimeout(this.clickTimeout);
      this.clickTimeout = null;
      return this.onRowDoubleClick();
    }

    this.clickTimeout = setTimeout(() => {
      clearTimeout(this.clickTimeout);
      this.clickTimeout = null;

      const { row, hasSelection } = this.props;

      if (hasSelection) {
        const onSelection = this.props.onSelection || null;
        if (onSelection) {
          //onSelection(row);
        }
      }

      const onRowClick = this.props.onRowClick || null;
      if (onRowClick) {
        onRowClick(row);
      }
    }, 250);
  }

  onRowDoubleClick() {
    const onRowDoubleClick = this.props.onRowDoubleClick || null;
    if (onRowDoubleClick) {
      const { row } = this.props;
      onRowDoubleClick(row);
    }
  }

  render() {
    const { isEditing, isDeleting } = this.state;
    const { hasMultipleSelection } = this.props;
    const { row, selected, type } = this.props;

    const isHeader = type === "header";

    const RowComponent = this.props.rowComponent || null;
    const RowHeaderComponent = this.props.rowHeaderComponent || null;

    const classNames = [];

    if (type !== "header") {
      const isItemSelected = selected.includes(row.id);

      if (isEditing) {
        classNames.push("is-editing");
      }

      if (isDeleting) {
        classNames.push("is-deleting");
      }

      if (isItemSelected) {
        classNames.push("is-selected");
      }
    }

    return (
      <React.Fragment>
        <TableRow
          className={classNames.join(" ")}
          onClick={() => this.onRowClick()}
        >
          {hasMultipleSelection && <Selection {...this.props} />}
          <Columns
            {...this.props}
            isEditing={isEditing}
            isDeleting={isDeleting}
            onEditChange={(key, value) => this.onEditChange(key, value)}
          />
          <Actions
            {...this.props}
            isEditing={isEditing}
            isDeleting={isDeleting}
            onEdit={() => this.onEdit()}
            onDelete={() => this.onDelete()}
            onConfirm={() => this.onConfirm()}
            onCancel={() => this.onCancel()}
          />
        </TableRow>
        {isHeader && RowHeaderComponent && (
          <RowHeaderComponent {...this.props} />
        )}
        {!isHeader && RowComponent && <RowComponent {...this.props} />}
      </React.Fragment>
    );
  }
}

export default Row;
